<template>
<CustomInput
  class="sms-code-component"
  v-bind="$attrs"
  v-on="$listeners"
  :value="value"
  inputmode="numeric"
  autocomplete="one-time-code"
  minlength="4"
  maxlength="4"
  label="Код"
/>
</template>

<script>
import CustomInput from './CustomInput';

export default {
  components: {
    CustomInput
  },

  props: { value: {} }
}
</script>

<style lang="less">
.sms-code-component {
  @apply w-24;
}
</style>
